export const ACTION_TYPES = {
  JURISDICTIONS: 'JURISDICTIONS',
  SELECT_FUND: 'SELECT_FUND',
  ADDITIONAL_INFORMATION: 'ADDITIONAL_INFORMATION'
};

const data = [
  '201-Deposit bank including foreign branches',
  '202-Deposit bank excluding foreign branches',
  '203-Foreign branch of deposit bank',
  '204-Group of deposit bank',
  '205-Consolidation group of deposit bank',
  '206-Foreign credit institution subsidiary of consolidation group of deposit bank',
  '207-Large financial institution in consolidation group of deposit bank',
  '208-Sub consolidation group of deposit bank',
  '209-Credit institution with access to liquidity facility',
  '210-Financing institution including foreign branches',
  '211-Financing institution excluding foreign branches',
  '212-Foreign branch of financing institution',
  '213-Group of financing institution',
  '214-Consolidation group of financing institution',
  '215-Foreign credit institution subsidiary of consolidation group of financing institution',
  '216-Large financial institution in consolidation group of financing institution',
  '217-Sub consolidation group of financing institution',
  '218-Companies granting consumer credit',
  '220-Foreign-owned consolidation group of credit institution',
  '221-Branch of foreign credit institution engaged in deposit bank activities in Finland',
  '222-Branch of foreign credit institution engaged in other than deposit bank activities in Finland',
  '224-Foreign subsidiary group of consolidation group of deposit bank',
  '225-Finnish branch of non-EEA credit institution',
  '226-Finnish branch of EEA credit institution',
  '230-Asset management company which has previously held bank status',
  '231-Other asset management company',
  '232-Investment firm (without authorisation for dealing on own account or underwriting of financial instruments, company under chapter 6, section 1, subsection 4&5 of the Investment Firms Act)',
  '233-Group of asset management company',
  '234-Consolidation group of asset management company',
  '236-Financial holding company (credit institutions)',
  '237-Financial holding company (investment firms)',
  '246-Branch of foreign company engaged in investment firm activities in Finland',
  '251-UCITS fund',
  '252-UCITS fund management company offering asset management services',
  '253-Finnish branch of foreign fund management company, AIFM or combination of these',
  '254-UCITS fund management company excl. foreign branches',
  '255-Money market fund',
  '256-Foreign branch of UCITS fund management company',
  '257-Payment institution; voluntary organisation and foundation',
  '258-Payment institution; self-employed person',
  '259-Payment institution; others excl. credit institutions',
  '260-Central body; amalgamation',
  '261-Central body',
  '262-Consolidation group of central body',
  '264-Group of central body',
  '265-Sub financial conglomerate',
  '266-Financial conglomerate',
  '267-Group of amalgamation',
  '270-Authorities and cooperative institutions',
  '280-All savings banks and groups (code 4999998)',
  '281-All savings banks excluding limited-liability savings banks (code 4999999)',
  '283-All cooperative banks and groups (code 5999988, 5999977)',
  '284-All cooperative banks excluding limited-liability cooperative banks (code 5999988,5999977)',
  '287-Central financial institution of savings banks',
  '288-Central financial institution of cooperative banks in amalgamation of cooperative banks',
  '289-Central financial institution for POP Banks',
  '291-Commercial bank excluding foreign branches',
  '292-Commercial bank including foreign branches',
  '294-All savings banks (201) (code 4999999)',
  '295-All cooperative banks (201) (code 5999988, 5999977)',
  '296-All savings banks (202), excluding foreign branches (code 4999999)',
  '297-All cooperative banks (202), excluding foreign branches (code 5999988, 5999977)',
  '349-Alternative investment fund (AIF)',
  '350-Registered AIFM',
  '351-Authorised AIFM (opt-in)',
  '352-Authorised AIFM with only unleveraged AIFs investing in non-listed companies and issuers in order to acquire control',
  '353-Authorised AIFM (medium)',
  '354-Authorised AIFM (large)',
  '361-Non EEA AIFM (small)',
  '362-Non EEA AIFM with only unleveraged AIFs investing in non-listed companies and issuers in order to acquire control',
  '363-Non EEA AIFM (medium)',
  '364-Non EEA AIFM (large)',
  '371-Authorised AIFM (opt-in) offering asset management services',
  '372-Authorised AIFM with only unleveraged AIFs investing in non-listed companies and issuers in order to acquire control offering asset management services',
  '373-Authorised AIFM (medium) offering asset management services',
  '374-Authorised AIFM (large) offering asset management services',
  '381-Combination: UCITS fund management company & Registered AIFM',
  '382-Combination: UCITS fund management company & Authorised AIFM (opt-in)',
  '383-Combination: UCITS fund management company & Authorised AIFM with only unleveraged AIFs investing in non-listed companies and issuers in order to acquire control',
  '384-Combination: UCITS fund management company & Authorised AIFM (medium)',
  '385-Combination: UCITS fund management company & Authorised AIFM (large)',
  '386-Combination: UCITS fund management company & Authorised AIFM (opt-in) offering asset management services',
  '387-Combination: UCITS fund management company & Authorised AIFM with only unleveraged AIFs investing in non-listed companies and issuers in order to acquire control offering asset management services',
  '388-Combination: UCITS fund management company & Authorised AIFM (medium) offering asset management services',
  '389-Combination: UCITS fund management company & Authorised AIFM (large) offering asset management services',
  '390-Combination: UCITS fund management company offering asset management services & Registered AIFM',
  '391-Combination: UCITS fund management company offering asset management services & Authorised AIFM (opt-in)',
  '392-Combination: UCITS fund management company offering asset management services & Authorised AIFM with only unleveraged AIFs investing in non-listed companies and issuers in order to acquire control',
  '393-Combination: UCITS fund management company offering asset management services & Authorised AIFM (medium)',
  '394-Combination: UCITS fund management company offering asset management services & Authorised AIFM (large)',
  '395-Combination: UCITS fund management company offering asset management services & Authorised AIFM (opt-in) offering asset management services',
  '396-Combination: UCITS fund management company offering asset management services & Authorised AIFM with only unleveraged AIFs investing in non-listed companies and issuers in order to acquire control offering asset management services',
  '397-Combination: UCITS fund management company offering asset management services & Authorised AIFM (medium) offering asset management services',
  '398-Combination: UCITS fund management company offering asset management services & Authorised AIFM (large) offering asset management services',
  '401-Employee pension insurance company',
  '405-Financial conglomerate primarily engaged in insurance activities',
  '406-Insurance holding company',
  '407-Insurance Conglomerate',
  '408-Mixed-activity insurance holding company',
  '410-Life insurance undertaking including foreign branches',
  '414-Life insurance group',
  '420-Non-life insurance undertaking company including foreign branches',
  '424-Non-life insurance group',
  '430-Insurance association',
  "435-Farmers' Social Insurance Institution (Mela)",
  "436-Seafarer's Pension Fund (MEK)",
  '437-Other pension institutions',
  '440-Industry-wide pension fund',
  '441-Industry-wide pension fund, division A (supplementary pension)',
  '442-Industry-wide pension fund, division B (statutory pension)',
  '443-Industry-wide pension fund, defined contribution fund',
  '445-Employee sickness fund',
  '446-Employee sickness fund, fund engaged in Health Insurance Act activities',
  '447-Employee sickness fund, supplementary fund',
  '448-Funeral and redundancy relief fund',
  '450-Company pension fund',
  '451-Company pension fund, division A (supplementary pension)',
  '452-Company pension fund, division B (statutory pension)',
  '453-Company pension fund, defined contribution fund',
  '460-Unemployment fund',
  '465-A foreign EEA branch in Finland',
  '466-A foreign EEA undertaking that pursues business in Finland under the freedom to provide services',
  '467-Finnish branch of a non-EEA non-life undertaking',
  '468-Finnish branch of non-EEA life insurance undertaking',
  '475-Insurance broker',
  '476-Insurance broker, life insurance',
  '477-Insurance broker, non-life insurance',
  '720-Investment firm (does not meet all the conditions of IFR Article 12), class 2',
  '721-Consolidation group of Investment firm (does not meet all the conditions of IFR Article 12), class 2',
  '722-Consolidation group of Investment firm, traded on stock exchange (does not meet all the conditions of IFR Article 12), class 2',
  '730-Investment firm (meets the conditions of IFR Article 12), class 3',
  '731-Consolidation group of Investment firm (meets the conditions of IFR Article 12), class 3',
  '732-Consolidation group of Investment firm, traded on stock exchange (meets the conditions of IFR Article 12), class 3',
  '801-Virtual currency providers',
  '802-Central Securities Depositories',
  '803-Money remitter',
  '804-Account information service provider'
];

export const reportingInstitutions = data.map(item => {
  return { value: item, label: item };
});
